import {HTTP} from '@/http-common';
import Router from '@/router';

import {clearUserData} from "../http-common";

export default {

  user: {
    authenticated: false
  },

  login(context, creds, redirect) {

    HTTP.post(`users/auth`, creds)
      .then((response) => {

        if (response.data.status === 'success') {
          localStorage.setItem('id_token', response.data.data.token);
          localStorage.setItem('user_account', JSON.stringify(response.data.data));
          clearUserData();

          HTTP.defaults.headers = {
            Token: response.data.data.token
          };

          this.user.authenticated = true;

          if (redirect) {
            Router.push(redirect);
          }

        }

        if (response.data.status === 'error') {
          context.errorLogin = true;
          context.button.stop();
          return false;
        }


        context.button.stop();

      }).catch(err => {
      console.log(err);
    });

  },

  logout() {
    HTTP.post('users/logout').catch(err => {
      console.log(err)
    });

    clearUserData();
    localStorage.removeItem('id_token');
    localStorage.removeItem('user_account');

    this.user.authenticated = false;

    Router.push('/login');

  },

  lock() {
    localStorage.removeItem('id_token');
    Router.push('/lock');
  },

  checkAuth() {
    if (localStorage.getItem('id_token') === null) {
      Router.push('/login');
      return false;
    }

    return true;
  },

  checkValidToken() {
    HTTP.post(`users/check`, localStorage.getItem('id_token'))
      .then(response => {
        if(response.data.status === 'error') {
          this.lock();
        }
      }).catch(err => {
      console.log(err);
    });
  },
}



// WEBPACK FOOTER //
// ./src/auth/index.js